import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { TreeViewService } from '@core/components/fc-tree-view/fc-tree-view.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { delay } from '@core/utils/delay';
import { LocationTabLinksService } from 'app/main/locations/dialogs/dialog-location/tabs/links/tab-links.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import { TabLinksService } from '../tab-links.service';
import { DialogLinkService } from './dialog-link.service';
var DialogLinkComponent = /** @class */ (function () {
    function DialogLinkComponent(dialogData, tabLinksService, treeViewService, dialogLinkService, changeDetectorRef, messageService, matDialogRef, locationLinksTabModalService) {
        this.dialogData = dialogData;
        this.tabLinksService = tabLinksService;
        this.treeViewService = treeViewService;
        this.dialogLinkService = dialogLinkService;
        this.changeDetectorRef = changeDetectorRef;
        this.messageService = messageService;
        this.matDialogRef = matDialogRef;
        this.locationLinksTabModalService = locationLinksTabModalService;
        this.isEmpty = false;
        this.isLoading = true;
        this.searchControl = new FormControl();
        this.equipments = [];
        this.locationSectors = [];
        this.locationEnvironments = [];
        this.locationLinks = [];
        this.unlinkedEquipments = [];
        this.destroy$ = new Subject();
        this.dialogLinkService.linkedSectors = this.dialogData.linkedSectors;
        this.dialogLinkService.linkedEquipments = this.dialogData.linkedEquipments;
        this.dialogLinkService.linkedEnvironments = this.dialogData.linkedEnvironments;
    }
    DialogLinkComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadLocationLinks()];
                    case 1:
                        _a.sent();
                        this.searchControl.valueChanges
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a, sectors, environments, equipments;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = this.dialogLinkService.getLinkedItems({
                                            locationLinks: this.locationLinks,
                                            unlinkedEquipments: this.unlinkedEquipments,
                                            sectors: this.locationSectors,
                                            equipments: this.equipments,
                                            environments: this.locationEnvironments,
                                        }), sectors = _a.sectors, environments = _a.environments, equipments = _a.equipments;
                                        this.dialogLinkService.linkedSectors = sectors;
                                        this.dialogLinkService.linkedEquipments = equipments;
                                        this.dialogLinkService.linkedEnvironments = environments;
                                        return [4 /*yield*/, this.loadLocationLinks()];
                                    case 1:
                                        _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.treeViewService.checked$
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(function (item) {
                            if (item.metadata === 'sector') {
                                var linkedSector = _this.dialogLinkService.linkedSectors.find(function (linkedItem) { return linkedItem.id === item.id; });
                                if (!linkedSector) {
                                    if (item.action.checked) {
                                        _this.dialogLinkService.linkedSectors.push(item.original);
                                    }
                                    return;
                                }
                                if (!item.action.checked) {
                                    _this.dialogLinkService.linkedSectors = _this.dialogLinkService.linkedSectors.filter(function (linkedItem) { return linkedItem.id !== item.id; });
                                    _this.dialogLinkService.linkedEnvironments = _this.dialogLinkService.linkedEnvironments.filter(function (linkedItem) { return linkedItem.locationSector.id !== item.id; });
                                    _this.dialogLinkService.linkedEquipments = _this.dialogLinkService.linkedEquipments.filter(function (linkedItem) { return !linkedItem.locationSector || linkedItem.locationSector.id !== item.id; });
                                }
                            }
                            if (item.metadata === 'environment') {
                                var linkedEnvironment = _this.dialogLinkService.linkedEnvironments.find(function (linkedItem) { return linkedItem.id === item.id; });
                                if (!linkedEnvironment) {
                                    if (item.action.checked) {
                                        _this.dialogLinkService.linkedEnvironments.push(item.original);
                                    }
                                    return;
                                }
                                if (!item.action.checked) {
                                    _this.dialogLinkService.linkedEnvironments = _this.dialogLinkService.linkedEnvironments.filter(function (linkedItem) { return linkedItem.id !== item.id; });
                                    _this.dialogLinkService.linkedEquipments = _this.dialogLinkService.linkedEquipments.filter(function (linkedItem) { return !linkedItem.locationEnvironment || linkedItem.locationEnvironment.id !== item.id; });
                                }
                            }
                            if (item.metadata === 'equipment') {
                                var linkedEquipment = _this.dialogLinkService.linkedEquipments.find(function (linkedItem) { return linkedItem.id === item.id; });
                                if (!linkedEquipment) {
                                    if (item.action.checked) {
                                        _this.dialogLinkService.linkedEquipments.push(item.original);
                                    }
                                    return;
                                }
                                if (!item.action.checked) {
                                    _this.dialogLinkService.linkedEquipments = _this.dialogLinkService.linkedEquipments.filter(function (linkedItem) { return linkedItem.id !== item.id; });
                                }
                            }
                        });
                        this.treeViewService.checkAll$
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(function () {
                            _this.locationLinks.forEach(function (sector) {
                                sector.action.checked = true;
                                if (sector.children && sector.children.length) {
                                    sector.children.forEach(function (environmentOrEquipment) {
                                        environmentOrEquipment.action.checked = true;
                                        if (environmentOrEquipment.children && environmentOrEquipment.children.length) {
                                            environmentOrEquipment.children.forEach(function (equipment) {
                                                equipment.action.checked = true;
                                            });
                                        }
                                    });
                                }
                            });
                            _this.unlinkedEquipments.forEach(function (equipment) {
                                equipment.action.checked = true;
                                equipment.children.forEach(function (eq) {
                                    eq.action.checked = true;
                                });
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLinkComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    DialogLinkComponent.prototype.checkAll = function () {
        this.treeViewService.checkAll$.next();
        this.changeDetectorRef.markForCheck();
    };
    DialogLinkComponent.prototype.save = function () {
        var result = this.dialogLinkService.getLinkedItems({
            locationLinks: this.locationLinks,
            unlinkedEquipments: this.unlinkedEquipments,
            sectors: this.locationSectors,
            equipments: this.equipments,
            environments: this.locationEnvironments,
        });
        this.matDialogRef.close(result);
    };
    DialogLinkComponent.prototype.loadLocationLinks = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, locationSectors, locationEnvironments, equipments;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, Promise.all([
                                this.searchLocationSectors(),
                                this.searchLocationEnvironments(),
                                this.searchEquipments(),
                                delay(500)
                            ]).catch(function (error) {
                                _this.messageService.error('UNKNOWN_ERROR');
                                sentry.captureException(error);
                                return [[], [], []];
                            })];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), locationSectors = _a[0], locationEnvironments = _a[1], equipments = _a[2];
                        this.equipments = equipments;
                        this.locationSectors = locationSectors;
                        this.locationEnvironments = locationEnvironments;
                        return [4 /*yield*/, this.populateLocationLinks()];
                    case 2:
                        _b.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLinkComponent.prototype.searchLocationSectors = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinksTabModalService.searchLocationSectors({
                        locationId: this.dialogData.locationId,
                        archived: false,
                    })];
            });
        });
    };
    DialogLinkComponent.prototype.searchLocationEnvironments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinksTabModalService.searchLocationEnvironments({
                        locationId: this.dialogData.locationId,
                        archived: false,
                    })];
            });
        });
    };
    DialogLinkComponent.prototype.searchEquipments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinksTabModalService.searchEquipments({
                        locationId_in: [this.dialogData.locationId],
                        segmentId_in: [this.dialogData.segmentId],
                        archived: false,
                    })];
            });
        });
    };
    DialogLinkComponent.prototype.populateLocationLinks = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, _a, sectors, unlinkedEquipments, unfilteredLocationLinks, unfilteredUnlinkedEquipments;
            return tslib_1.__generator(this, function (_b) {
                data = {
                    sectors: this.locationSectors,
                    environments: this.locationEnvironments,
                    equipments: this.equipments,
                };
                _a = this.tabLinksService.linkSectorsEnvironmentsEquipments(data), sectors = _a.sectors, unlinkedEquipments = _a.unlinkedEquipments;
                unfilteredLocationLinks = this.dialogLinkService.formatSectors({ sectors: sectors, data: data });
                unfilteredUnlinkedEquipments = this.dialogLinkService.formatUnlinkedEquipments({ unlinkedEquipments: unlinkedEquipments });
                this.locationLinks = this.tabLinksService.filter(unfilteredLocationLinks, this.searchControl.value);
                this.unlinkedEquipments = this.tabLinksService.filter(unfilteredUnlinkedEquipments, this.searchControl.value);
                this.isEmpty = !this.locationLinks.length && !this.unlinkedEquipments.length;
                return [2 /*return*/];
            });
        });
    };
    return DialogLinkComponent;
}());
export { DialogLinkComponent };
